import 'lazysizes';

import header from './components/header.js';
import form from './components/form.js';

window.addEventListener('load', () => {
  header();
  form();
});